import {
  laravelGet,
  laravelPost,
  laravelDelete,
} from '../utils/laravelClient';
import { FETCH_CREDENTIALS } from '../utils/laravelClient';
import { API_BASE_URL } from '../config/env';
import { adminSession } from '../utils/session';
import { parseLaravelError, ApiError } from '../utils/laravelError';
import { handleAuthFailure } from '../utils/authRealm';

const AUTH = { auth: 'admin' };
const PUBLIC = { auth: 'none' };

export const getShopItems = () => laravelGet('/loyalty-shop', PUBLIC);

export const getShopItem = (id) => laravelGet(`/loyalty-shop/${id}`, PUBLIC);

export const getPromotedShopItems = () => laravelGet('/loyalty-shop/promoted', PUBLIC);

export const getShopItemsAdmin = () => laravelGet('/loyalty-shop-admin', AUTH);

async function multipartRequest(method, path, formData) {
  const token = adminSession.getBearerToken();
  const headers = {
    Accept: 'application/json',
  };
  if (token) {
    headers.Authorization = `Bearer ${token}`;
  }

  const response = await fetch(`${API_BASE_URL.replace(/\/$/, '')}${path}`, {
    method,
    headers,
    credentials: FETCH_CREDENTIALS,
    body: formData,
  });

  if (response.ok) {
    return response.json();
  }

  const errorPayload = await parseLaravelError(response);
  if (errorPayload.status === 401) {
    handleAuthFailure('admin');
    throw new ApiError({ ...errorPayload, silent: true });
  }
  throw new ApiError(errorPayload);
}

export async function createShopItem(formData) {
  return multipartRequest('POST', '/loyalty-shop', formData);
}

export async function updateShopItem(id, formData) {
  formData.append('_method', 'PUT');
  return multipartRequest('POST', `/loyalty-shop/${id}`, formData);
}

export const deleteShopItem = (id) => laravelDelete(`/loyalty-shop/${id}`, AUTH);

export const purchaseShopItem = (itemId, userId, notes = null) =>
  laravelPost(`/loyalty-shop/${itemId}/purchase/${userId}`, { notes }, AUTH);

export const getShopPurchases = (page = 1) =>
  laravelGet('/loyalty-shop-purchases', { ...AUTH, params: { page } });

export const getUserPurchases = (userId) =>
  laravelGet(`/loyalty-shop-purchases/user/${userId}`, AUTH);
